"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function binaryTreeToQueryJson(tree) {
    let query = {};
    if (!tree || !tree.lexeme) {
        return query;
    }
    let cursor = tree;
    let currentType = tree.lexeme.type;
    query.type = currentType;
    if (currentType === 'string' || currentType === 'attr') {
        query.value = tree.lexeme.value;
        return query;
    }
    query.values = [];
    while (cursor && cursor.lexeme.type === currentType) {
        if (cursor.left) {
            query.values.push(binaryTreeToQueryJson(cursor.left));
        }
        cursor = cursor.right;
    }
    if (cursor) {
        query.values.push(binaryTreeToQueryJson(cursor));
    }
    return query;
}
exports.binaryTreeToQueryJson = binaryTreeToQueryJson;
